<template>
  <div class="flex-none bg-white dark:bg-gray-800 rounded-xl shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300">
    <div class="p-4 md:p-6">
      <!-- Profile Picture -->
      <div class="w-10 h-10 md:w-12 md:h-12 bg-primary rounded-full flex items-center justify-center mb-3 md:mb-4">
        <span class="text-lg md:text-xl text-white font-semibold">
          {{ profile?.first_name?.[0] || "?" }}
        </span>
      </div>

      <!-- Basic Info -->
      <div class="space-y-1.5">
        <h4 class="text-base md:text-lg font-semibold text-gray-900 dark:text-white mb-1 md:mb-2 line-clamp-1">
          {{ profile?.title || "" }} {{ profile?.first_name || "" }}
          {{ profile?.last_name || "" }}
        </h4>
        <p class="text-xs md:text-sm text-gray-600 dark:text-gray-300 line-clamp-2">
          {{ profile?.institution || "Institution not specified" }}
        </p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
interface ProfileAttributes {
  title: string;
  first_name: string;
  last_name: string;
  institution: string;
}

defineProps<{
  profile: ProfileAttributes;
}>();
</script>
